import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import EllipseIcon from "../../shared/icons/EllipseIcon";
import CustomButton from "../../custom/custom-button/CustomButton";
import style from "./CreateOrderPopup.module.scss";

const ORDER_OPTIONS = [
  {
    key: "single",
    image: "/images/single_order.png",
    path: "/orders/create",
    ellipseColor: "#C5D2FF",
  },
  {
    key: "bulk",
    image: "/images/excel.png",
    path: "/orders/bulk-create",
    ellipseColor: "#D5FFEC",
    buttonColor: "#0D8751",
  },
  // {
  //   key: "complex-tender",
  //   image: "/images/transports.png",
  //   path: "/orders/complex-tender/create",
  //   ellipseColor: "#EBE4FF",
  //   buttonColor: "#5D32D0",
  // },
];

const BUTTON_STYLE = {
  height: 36,
  fontSize: 14,
  fontWeight: 500,
};

const CreateOrderPopup = ({ onClose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  const handleSelect = (path) => {
    navigate(path);
    onClose();
  };

  return createPortal(
    <div className={style.overlay} onClick={onClose}>
      <div
        className={style.modal}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        >
        <div className={style.topbar}>
          <h2 className={style.title}>{t("createOrderPopup.title")}</h2>
          <button
            type="button"
            className={style.close}
            onClick={onClose}
            aria-label={t("common.close")}
          >
            <X size={24} color="#212121" />
          </button>
        </div>

        <div className={style.cards}>
          {ORDER_OPTIONS.map((option) => (
            <div key={option.key} className={style.card}>
              <div className={style.cardBody}>
                <div className={style.cardImage}>
                  <EllipseIcon
                    className={style.cardImageBackground}
                    color={option.ellipseColor}
                    aria-hidden="true"
                  />
                  <img src={option.image} alt={t(`createOrderPopup.options.${option.key}.title`)} />
                </div>
                <div className={style.cardText}>
                  <h3 className={style.cardTitle}>{t(`createOrderPopup.options.${option.key}.title`)}</h3>
                  <p className={style.cardDescription}>
                    {t(`createOrderPopup.options.${option.key}.description`)}
                  </p>
                </div>
              </div>
              <CustomButton
                text={t(`createOrderPopup.options.${option.key}.buttonText`)}
                isFall
                isNavy
                onClick={() => handleSelect(option.path)}
                style={{
                  ...BUTTON_STYLE,
                  ...(option.buttonColor ? { backgroundColor: option.buttonColor } : {}),
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default CreateOrderPopup;
